/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { MessageTipModule } from 'app/feature/auth/message-tip/message-tip.module';
import { CreateModule } from 'app/feature/protection/schedule/hyper-cdp/schedule/create/create.module';

import { CopyFromCifsShareSModule } from '../../share/cifs-share/copy-from-cifs-share-s/copy-from-cifs-share-s.module';
import { CopyFromNfsShareSModule } from '../../share/nfs-share/copy-from-nfs-share-s/copy-from-nfs-share-s.module';
import { CreateFileShareComponent } from './create-file-share.component';
import { ModifyShareNameModule } from './modify-share-name/modify-share-name.module';

@NgModule({
    declarations: [CreateFileShareComponent],
    exports: [CreateFileShareComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        CopyFromNfsShareSModule,
        CopyFromCifsShareSModule,
        MessageTipModule,
        CreateModule,
        ModifyShareNameModule,
    ],
})
export class CreateFileShareModule { }
